import axios from 'axios';
import Cookies from "js-cookie";
import urlApis from '../Api.config';

/**
 *Proporciona los servicios para manejar los tramites de planeacion
 * @author Milbelis Velásquez Tovar
 */


export default class ServicesTramiteshacienda{
    constructor(){}

    /**
     * TRAMITES EXTERNOS DE PLANEACION
     * @return listado de tramites
     */
    getTramitesExternos(){
        let target = urlApis.apiFormatos().get('/formatosExternos/').then(
            function (res)
            {
                // console.log('getTramitesExternos()');
                let success = res.status==200? true : false;

                if(success){
                    let obj = { "success": success, "data": res.data, "error": '' }
                    return obj;
                }

            }).catch((error) =>{
                let obj = { "success": false, "data": '', "error": error }
                return obj;
            });
        return target;

    }



    /**
     * Guarda el token generado, y la otra funcion obtiene el token
     * @returns token
     */
    setUserToken(token) {
        Cookies.set("token_tramites", token);
    }

    getUserToken() {
        return Cookies.get("token_tramites");
    }


    /**
     * Obtiene el nombre de usuario
     * @returns Usuario
     */
    getIdUsuario() {
        return Cookies.get("idUsuario");
    }

    /**
     * estas 2 funciones retornan una el nommbre y la otra el token de logueo
     * @returns nommbre y la otra el token de logueo
     */
    getUsuarioName() {
        return Cookies.get("userName");
    }
    getTokenAuth() {
        return Cookies.get("token_auth");
    }
    /**
     * Borra datos de la cookie
     * @returns eliminado elementos de la cookie
     */
    deleteUserLogged() {
        Cookies.remove('idUsuario')
        // Cookies.remove('usuario');
        Cookies.remove('userName');
        Cookies.remove('token_auth');
        Cookies.remove('token_tramites');

    }

    /**
     * Obtiene Token de autenticacion de tramites directamente haciendo la peticion desde el front
     * @returns token
     */
     async GetToken2()
    {
        // const url = 'http://200.57.183.210/SIFOSH/api/login/authenticate';
        // const data = { username: 'usrSH', password: 'O2=clrUL' };
        let target = axios.post(url, data).then(
            function (res)
            {
                let success = res.status==200? true : false;

                if(success){
                    let obj = { "success": success, "data": res.data, "error": '' }
                    return obj;
                }

            }).catch((error) =>{
                let obj = { "success": false, "data": '', "error": error }
                return obj;
            });
        return target;
    }

    /**
     * Obtiene Token de autenticacion de tramites desde archivo php
     * @returns token
     */
    async GetToken()
    {
        //console.log('this');
        let target = urlApis.serverTramitesHacienda().get().then(
            function (res)
            {
                //console.log('get token de serviciosTramites');
                // console.log(res);
                let success = res.status==200? true : false;

                let obj = { "success": success, "data": res.data, "error": '' }
                return obj;

            }).catch((error) =>{
                let obj = { "success": false, "data": '', "error": error }
                return obj;
            });
        return target;
    }

    /**
     * Obtiene listado de subsecretarias
     * @returns Listado de subsecretarias
     */
    async Subsecretarias(){ //async Subsecretarias(token){   //"Token":token
    //    let config = {
    //         headers:{
    //             "Allow":"GET, POST, OPTIONS, PUT, DELETE",
    //             "Access-Control-Allow-Origin":"*",
    //             "Content-type":"Application/json",

    //         }
    //     }
        //console.log('jashdghjasdvgkasgdkjash');
        // console.log('async Subsecretarias('+token+')');
        let target = urlApis.apiFormatos().get('/subsecretarias').then(  //let target = urlApis.apiFormatos().get('/subsecretarias', config).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                if(error == 'Error: Request failed with status code 401'){
                    // console.log('ERROR 401');
                }
                // console.log('ERROR 401 = '+ error);
                return error;
            });
        return target;
    }

    /**
     * Obtiene listado de direcciones vinculadas a una subsecretaría
     * @returns Listado de direcciones
     */
    async GetDirecciones(idSubsecretaria){   //async GetDirecciones(token, idSubsecretaria){
        // let config = {
        //     headers:{
        //         "Allow":"GET, POST, OPTIONS, PUT, DELETE",
        //         "Access-Control-Allow-Origin":"*",
        //         "Content-type":"Application/json",
        //         "Token":token
        //     }
        // }
        // console.log('async GetDirecciones('+token+','+ idSubsecretaria+')');
        let target = urlApis.apiFormatos().get('/direcciones/'+idSubsecretaria).then(   //let target = urlApis.apiFormatos().get('/direcciones/'+idSubsecretaria, config).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                return error;
            });
        return target;
    }

    /**
     * Obtiene listado de formatos combinado
     * Parámetros:
     * ss: id de la subdirección, poner 0 para ignorar.
     * dir: id de la dirección, poner 0 para ignorar.
     * tipo: tipo de formato 1 para externos, 2 para internos, 0 para ignorar.
     * busqueda: texto para filtrar, dejar vacío para ignorar
     * @returns listado de formatos
     */
     async filtroGenericoFormatos(idSubsecretaria, idDireccion, tipo, palabra){
        let target = urlApis.apiFormatos().get('/filtro?ss='+ idSubsecretaria +'&dir='+ idDireccion +'&tipo='+ tipo +'&busqueda='+ palabra).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                return error;
            });
        return target;
    }


    /**
     * Obtiene listado de formatos de una direccion
     * @returns Listado de formatos
     */
    async GetFormatos(token, idDireccion){
        //  console.log('async GetFormatos', token);
        let config = {
            headers:{
                "Allow":"GET, POST, OPTIONS, PUT, DELETE",
                "Access-Control-Allow-Origin":"*",
                "Content-type":"Application/json",
                "Token":token
            }
        }
        let target = urlApis.apiFormatos().get('/formatosDireccion/'+idDireccion, config).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                return error;
            });
        return target;
    }

    /**
     * Obtiene listado de busqueda por palabra de formatos
     * @returns Listado de busqueda por palabra
     */
    async GetBuscadorFormatos(token, palabra){
        // console.log('async GetBuscadorFormatos('+token+','+ palabra+')');
        let config = {
            headers:{
                "Allow":"GET, POST, OPTIONS, PUT, DELETE",
                "Access-Control-Allow-Origin":"*",
                "Content-type":"Application/json",
                "Token":token
            }
        }
        let target = urlApis.apiFormatos().get('/formatos/'+palabra, config).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                return error;
            });
        return target;
    }

    /**
    * Obtiene listado de busqueda por palabra de formatos
    * @returns Listado de busqueda por palabra
    */
    async GetTramite(token, idTramite){
        //console.log('async GetTramite('+token+','+ idTramite+')');
        let config = {
            headers:{
                "Allow":"GET, POST, OPTIONS, PUT, DELETE",
                "Access-Control-Allow-Origin":"*",
                "Content-type":"Application/json",
                "Token":token
            }
        }
        let target = urlApis.apiFormatos().get('/formatosTramServ/'+idTramite, config).then(
            function (res)
            {
                // armar respuesta cuando liberen los servicios
                return res;

            }).catch((error) =>{
                return error;
            });
        return target;
    }

}

